import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    // A list of all locales that are supported
    locales: ['en', 'de'],
    // locales: ['de'],
    localeDetection: false,

    defaultLocale: 'de',
    localePrefix: 'as-needed' // makes the locale prefix optional in the URL -> /en/about vs /about
});